import { generateClient } from "aws-amplify/data";
import { updateGlobalVocabulary } from "../graphql/mutations";
import { updateUserVocabulary } from "../graphql/mutations";

export async function updateGlobalItem(
  id, // ID of the item to be updated
  translation = null, // Optional translation to update
  speechUrl = null // Optional speech URL to update
) {
  // Generate an Amplify client
  const client = generateClient();

  // Create an object to hold the updated fields
  let updatedItem = {
    id: id, // Set the ID of the item to be updated
  };

  // If a translation is provided, add it to the updatedItem object
  if (translation) {
    updatedItem.translation = translation;
  }

  // If a speech URL is provided, add it to the updatedItem object
  if (speechUrl) {
    updatedItem.textToSpeech = speechUrl;
  }

  try {
    // Execute the GraphQL mutation to update the item in the global vocabulary
    await client.graphql({
      query: updateGlobalVocabulary, // The mutation to execute
      variables: { input: updatedItem }, // The input variables for the mutation
    });
  } catch (error) {
    // Log any errors that occur during the update
    console.log("Failed to update item:", error);
  }
}

export async function updateUserItem(
  id, // ID of the item to be updated
  translation = null, // Optional translation to update
  progress = null // Optional progress meter to update
) {
  // Generate an Amplify client
  const client = generateClient();

  // Create an object to hold the updated fields
  let updatedItem = {
    id: id, // Set the ID of the item to be updated
  };

  // If a translation is provided, add it to the updatedItem object
  if (translation) {
    updatedItem.translation = translation;
  }

  // If a speech URL is provided, add it to the updatedItem object
  if (progress) {
    updatedItem.progress = progress;
  }

  try {
    // Execute the GraphQL mutation to update the item in the global vocabulary
    await client.graphql({
      query: updateUserVocabulary, // The mutation to execute
      variables: { input: updatedItem }, // The input variables for the mutation
    });
  } catch (error) {
    // Log any errors that occur during the update
    console.log("Failed to update item:", error);
  }
}
